import date from "@common/lib/date";
import { type I18n } from "@common/lib/i18n";
import {
  addDays,
  addMonths,
  endOfDay,
  endOfMonth,
  endOfWeek,
  isSameDay,
  startOfDay,
  startOfMonth,
  startOfWeek
} from "date-fns";
import { type DateRangeValue } from "./component";

export const formatDisplayValue = (i18n: I18n, mixed: DateRangeValue | string | null): string => {
  const range = parseValue(mixed);
  if (!range || (!range.from && !range.to)) return "";
  return `${range.from ? date.formatDate(range.from) : i18n.from} - ${range.to ? date.formatDate(range.to) : i18n.to}`;
};

export const parseValue = (value: string | DateRangeValue | null): DateRangeValue | null => {
  if (!value) return null;
  if (typeof value === "object") return value as DateRangeValue;

  try {
    const v = JSON.parse(value);
    return {
      from: new Date(v.from),
      to: new Date(v.to)
    };
  } catch {
    return null;
  }
};

// react-date-range returns date w/o considering the timezone, thus we add it and shift to start/end of day
export const toOutput = (date: Date | undefined, isStart: boolean): Date | null => {
  if (!date) return null;

  const offset = date.getTimezoneOffset() * 60000;
  return new Date((isStart ? startOfDay(date) : endOfDay(date)).getTime() - offset);
};

// react-date-range expects date w/o considering the timzone, thus we remove it
export const toInput = (date: Date | undefined): Date | null => {
  if (!date) return null;

  const offset = date.getTimezoneOffset() * 60000;
  return new Date(date.getTime() + offset);
};

const defineds = {
  startOfToday: startOfDay(new Date()),
  endOfToday: endOfDay(new Date()),

  startOfTomorrow: startOfDay(addDays(new Date(), 1)),
  endOfTomorrow: endOfDay(addDays(new Date(), 1)),

  startOfWeek: startOfWeek(new Date()),
  endOfWeek: endOfWeek(new Date()),

  startOfNextWeek: startOfWeek(addDays(new Date(), 7)),
  endOfNextWeek: endOfWeek(addDays(new Date(), 7)),

  startOfMonth: startOfMonth(new Date()),
  endOfMonth: endOfMonth(new Date()),

  startOfNextMonth: startOfMonth(addMonths(new Date(), 1)),
  endOfNextMonth: endOfMonth(addMonths(new Date(), 1))
};

const staticRangeHandler = {
  range: {},
  isSelected(range) {
    const definedRange = this.range();
    return isSameDay(range.startDate, definedRange.startDate) && isSameDay(range.endDate, definedRange.endDate);
  }
};

export function createStaticRanges(ranges) {
  return ranges.map((range) => ({ ...staticRangeHandler, ...range }));
}

export const defaultStaticRanges = createStaticRanges([
  {
    label: "Today",
    range: () => ({
      startDate: defineds.startOfToday,
      endDate: defineds.endOfToday
    })
  },
  {
    label: "Tomorrow",
    range: () => ({
      startDate: defineds.startOfTomorrow,
      endDate: defineds.endOfTomorrow
    })
  },

  {
    label: "This Week",
    range: () => ({
      startDate: defineds.startOfWeek,
      endDate: defineds.endOfWeek
    })
  },
  {
    label: "Next Week",
    range: () => ({
      startDate: defineds.startOfNextWeek,
      endDate: defineds.endOfNextWeek
    })
  },
  {
    label: "This Month",
    range: () => ({
      startDate: defineds.startOfMonth,
      endDate: defineds.endOfMonth
    })
  },
  {
    label: "Next Month",
    range: () => ({
      startDate: defineds.startOfNextMonth,
      endDate: defineds.endOfNextMonth
    })
  }
]);

export const defaultInputRanges = [
  // {
  // 	label: 'days up to today',
  // 	range(value) {
  // 		return {
  // 			startDate: addDays(defineds.startOfToday, (Math.max(Number(value), 1) - 1) * -1),
  // 			endDate: defineds.endOfToday,
  // 		};
  // 	},
  // 	getCurrentValue(range) {
  // 		if (!isSameDay(range.endDate, defineds.endOfToday)) return '-';
  // 		if (!range.startDate) return '∞';
  // 		return differenceInCalendarDays(defineds.endOfToday, range.startDate) + 1;
  // 	},
  // },
  // {
  // 	label: 'days starting today',
  // 	range(value) {
  // 		const today = new Date();
  // 		return {
  // 			startDate: today,
  // 			endDate: addDays(today, Math.max(Number(value), 1) - 1),
  // 		};
  // 	},
  // 	getCurrentValue(range) {
  // 		if (!isSameDay(range.startDate, defineds.startOfToday)) return '-';
  // 		if (!range.endDate) return '∞';
  // 		return differenceInCalendarDays(range.endDate, defineds.startOfToday) + 1;
  // 	},
  // },
];
